export default __webpack_public_path__ + "static/media/features-split-image-02.49942613.png";